module.exports = __webpack_public_path__ + "img/icon_arrow_left_12@3x.f5f10bcc.png";